// extracted by mini-css-extract-plugin
export default {"root":"SvgIcon_root__WtjSV","icon":"SvgIcon_icon__mIplm"};